import { Box, Button, CircularProgress, IconButton, SxProps, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CheckCircleOutlined, ErrorOutline, WarningOutlined } from '@mui/icons-material';
import { useState } from 'react';
import { WarningAlert } from 'ui/WarningAlert';

export const ErrorBanner = ({
	text,
	buttonText,
	onClick,
	sx,
	buttonLoading,
	type = 'error',
	noClose = false,
}: {
	text: string;
	buttonText?: string;
	onClick?: () => void;
	sx?: SxProps;
	buttonLoading?: boolean;
	type?: 'error' | 'warning' | 'success';
	noClose?: boolean;
}) => {
	const [open, setOpen] = useState(true);
	if (!open) return null;
	return (
		<Box
			sx={{
				...sx,
				backgroundColor:
					type === 'error' ? 'error.main' : type === 'warning' ? 'warning.main' : 'success.main',
				color:
					type === 'error'
						? 'error.contrastText'
						: type === 'warning'
							? 'warning.contrastText'
							: 'success.contrastText',
				padding: 1,
			}}
		>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					{type === 'error' && <ErrorOutline sx={{ fontSize: '1.5rem' }} />}
					{type === 'warning' && <WarningOutlined sx={{ fontSize: '1.5rem' }} />}
					{type === 'success' && <CheckCircleOutlined sx={{ fontSize: '1.5rem' }} />}
					<Typography variant="body1">{text}</Typography>
				</Box>
				{!!buttonText && !!onClick && (
					<Button
						color="inherit"
						onClick={onClick}
						variant="outlined"
						sx={{ fontWeight: 'bold', position: 'relative' }}
					>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								gap: 1,
								justifyContent: 'center',
								position: 'absolute',
							}}
						>
							{buttonLoading && <CircularProgress size={20} sx={{ color: 'white' }} />}
						</Box>
						<Typography
							variant="body1"
							sx={{ fontWeight: 'bold', opacity: buttonLoading ? 0.4 : 1 }}
						>
							{buttonText}
						</Typography>
					</Button>
				)}
				{!noClose && (
					<IconButton color="inherit" onClick={() => setOpen(false)}>
						<CloseIcon />
					</IconButton>
				)}
			</Box>
		</Box>
	);
};
